import styled from "styled-components";
import { Button } from "antd";
import { ButtonProps } from "antd/es/button";

import "./vars.css";

interface IStyledButtonProps extends ButtonProps {
  bgColor: "red" | "green" | "yellow" | "blue" | "grey" | "orange";
}

export const StyledButton = (props: IStyledButtonProps) => {
  if (props.bgColor === "red") return <StyledRedButton {...props} />;
  if (props.bgColor === "green") return <StyledGreenButton {...props} />;
  if (props.bgColor === "yellow") return <StyledYellowButton {...props} />;
  if (props.bgColor === "blue") return <StyledBlueButton {...props} />;
  if (props.bgColor === "grey") return <StyledGreyButton {...props} />;
  if (props.bgColor === "orange") return <StyledOrangeButton {...props} />;
  return <Button {...props} />;
};

const StyledYellowButton = styled(Button)`
  &.ant-btn {
    background: var(--styled-antd-color-yellow-button);
    border-color: var(--styled-antd-color-yellow-button);
    color: white;
  }

  &.ant-btn:hover {
    background: white;
    border-color: var(--styled-antd-color-yellow-button);
    color: var(--styled-antd-color-yellow-button);
  }
`;

const StyledRedButton = styled(Button)`
  &.ant-btn {
    background: var(--styled-antd-color-red-button);
    border-color: var(--styled-antd-color-red-button);
    color: white;
  }

  &.ant-btn:hover {
    background: white;
    border-color: var(--styled-antd-color-red-button);
    color: var(--styled-antd-color-red-button);
  }
`;

const StyledBlueButton = styled(Button)`
  &.ant-btn {
    background: var(--styled-antd-color-blue-button);
    border-color: var(--styled-antd-color-blue-button);
    color: white;
  }

  &.ant-btn:hover {
    background: white;
    border-color: var(--styled-antd-color-blue-button);
    color: var(--styled-antd-color-blue-button);
  }
`;

const StyledGreenButton = styled(Button)`
  &.ant-btn {
    background: var(--styled-antd-color-green-button);
    border-color: var(--styled-antd-color-green-button);
    color: white;
  }

  &.ant-btn:hover {
    background: white;
    border-color: var(--styled-antd-color-green-button);
    color: var(--styled-antd-color-green-button);
  }
`;

const StyledGreyButton = styled(Button)`
  &.ant-btn {
    background: var(--styled-antd-color-grey-button);
    border-color: var(--styled-antd-color-grey-button);
    color: white;
  }

  &.ant-btn:hover {
    background: white;
    border-color: var(--styled-antd-color-grey-button);
    color: var(--styled-antd-color-grey-button);
  }
`;

const StyledOrangeButton = styled(Button)`
  &.ant-btn {
    background: var(--styled-antd-color-orange-button);
    border-color: var(--styled-antd-color-orange-button);
    color: white;
  }

  &.ant-btn:hover {
    background: white;
    border-color: var(--styled-antd-color-orange-button);
    color: var(--styled-antd-color-orange-button);
  }
`;
